<template>
    <div v-on:click="connectWalletHandler" class="connect-wallet-btn" v-bind:class="{'connect-wallet-btn--disabled': !walletLoaded}">
        <span class="muted" v-if="!walletLoaded">
            {{ $t('tonconnect.loading') }}
        </span>
        <template v-else>
            <template v-if="walletName">{{ walletName }} <arrow-right /></template>
            <span v-else>{{ $t('tonconnect.connect_wallet') }}</span>
        </template>
    </div>
</template>

<script>
import { THEME } from '@tonconnect/ui';
import { Address } from '~/tonweb';
import { getDomainByAddress } from '~/api/toncenterV3';
import ArrowRight from '@img/icons/tonscan/chevron-bottom-14.svg?inline';

export default {
    data() {
        return {
            openDropdown: false,
            walletName: null,
            walletLoaded: false,
            unsubscribe: null,
        };
    },

    mounted() {
        this.loadWallet();
    },

    methods: {
        loadWallet() {
            this.$tonConnect.connectionRestored.then((restored) => {
                if (restored) {
                    this.updateAddress();
                } else {
                    this.walletLoaded = true;
                }
            });

            this.unsubscribe = this.$tonConnect.onStatusChange((wallet) => {
                if (!wallet) {
                    // Кошелёк отключили где угодно
                    this.walletName = null;
                    this.walletLoaded = true; // кнопка активна
                    return;
                }

                this.updateAddress();
            });
        },
        async connectWalletHandler() {
            if (!this.$tonConnect.connected) {
                // Open connect modal
                await this.$tonConnect.openModal();

                this.$tonConnect.uiOptions = {
                    language: this.$store.state.appLocale,
                    uiPreferences: {
                        theme: this.$store.state.appTheme === 'light' ? THEME.LIGHT : THEME.DARK,
                    },
                };
            } else {
                // Open dropdown for the connected wallet
                this.$emit('open-wallet-dropdown');
            }
        },

        async updateAddress() {
            const addressRaw = this.$tonConnect.wallet?.account?.address;

            if (!addressRaw) return;

            const address = new Address(addressRaw).toString({
                userFriendly: true,
                bouncable: false,
                testOnly: false,
            });

            const domain = await getDomainByAddress(address);
            this.walletLoaded = true;

            if (domain) {
                this.walletName = domain.length > 15
                    ? domain.slice(0, 6) + '...' + domain.slice(-6)
                    : domain;
                return;
            }

            this.walletName = address.slice(0, 4) + '...' + address.slice(-4);
        },
    },

    beforeDestroy() {
        if (this.unsubscribe) this.unsubscribe();
    },

    components: {
        ArrowRight,
    },
};
</script>

<style scoped lang="scss">
.connect-wallet-btn {
    position: relative;
    height: 39px;
    border-radius: 8px;
    cursor: pointer;
    font-size: 13px;
    font-weight: 500;
    padding: 0 16px;
    margin: 0 6px 0 12px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    //text-transform: uppercase;
    transition: background-color .15s;
    color: var(--body-text-color);
    background-color: var(--body-light-muted-color);
    user-select: none;
    white-space: nowrap;

    &--disabled {
        cursor: default;
        //background: var(--big-blue-button-disabled-background);
        //color: var(--big-blue-button-disabled-color);
        pointer-events: none;
        padding: 0 16px;
    }

    svg {
        width: 10px;
        margin-left: 6px;
        margin-right: -4px;
    }
}
</style>
